export enum AccountStatus {
    HasNoVehicles = "HasNoVehicles",
    HasOneUnverifiedVehicle = "HasOneUnverifiedVehicle",
    HasOneOrMoreVerifiedVehicles = "HasOneOrMoreVerifiedVehicles",
}
